import { KpisPage } from "@/pages/kpis/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/kpis")({
    component: KpisPage,
});
